import React, { useState } from 'react';
import ExpandMore from '@mui/icons-material/ExpandMore';
import FAQTopic from './FAQTopic';
import FAQQuestion from './FAQQuestion';
import useFAQStore, { selectQuestions } from '../../../../stores/FAQStore';

interface IFAQTopicQuestionsProps {
  topicId?: string;
}

export default function FAQTopicQuestions({
  topicId,
}: IFAQTopicQuestionsProps) {
  const questions = useFAQStore((state) => selectQuestions(state, topicId));
  const [expanded, setExpanded] = useState(false);

  function toggleExpand() {
    setExpanded((prev) => !prev);
  }

  return (
    <div
      className={`bg-g10 overflow-hidden mt-4 transform transition-all rounded-[0.625rem]`}
    >
      <button
        className={`flex w-full overflow-hidden rounded-[0.625rem] bg-white border border-gainsboroGray`}
        onClick={toggleExpand}
      >
        <div className="self-stretch w-2 bg-primary" />

        <div className="flex gap-2 px-[2rem] items-center w-full justify-start">
          <div className="flex w-full gap-2 items-center justify-start">
            <div className="text-xl text-stormGray">
              The topic of your question:
            </div>

            <FAQTopic id={topicId} className="mr-4 my-2" />
          </div>

          <div
            className={`shrink-0 my-auto text-primary transform transition-transform duration-300 ${expanded ? 'rotate-180' : 'rotate-0'}`}
          >
            <ExpandMore sx={{ fontSize: '2rem' }} />
          </div>
        </div>
      </button>

      <div
        className={`overflow-hidden transition-[max-height] px-[2rem] duration-300 ${expanded ? 'max-h-[1000rem]' : 'max-h-0'}`}
      >
        <div className="flex flex-col py-6 gap-8">
          {questions?.map((faq) => (
            <FAQQuestion
              key={`faq_${topicId}_${faq.id}`}
              id={faq.id}
              topicId={faq.topicId}
              question={faq.question}
              answer={faq.answer}
              topicName=""
              enabled={faq.enabled}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
